const SENSITIVE_QUERY_PARAMS = new Set([
  'token',
  'access_token',
  'id_token',
  'refresh_token',
])

const toUrl = (value) => {
  try {
    return new URL(value)
  } catch {
    return null
  }
}

export const sanitizeUrl = (value) => {
  if (typeof value !== 'string' || value.length === 0) {
    return value
  }

  const url = toUrl(value)
  if (!url) {
    return value
  }

  for (const key of [...url.searchParams.keys()]) {
    if (SENSITIVE_QUERY_PARAMS.has(key.toLowerCase())) {
      url.searchParams.delete(key)
    }
  }

  return url.toString()
}

export const sanitizeCurrentLocationForHistory = (locationLike) => {
  if (!locationLike?.href) return null

  const sanitized = sanitizeUrl(locationLike.href)
  const url = toUrl(sanitized)
  if (!url) return null

  return `${url.pathname}${url.search}${url.hash}`
}
